const GRID_START_HOUR = 7;
const GRID_END_HOUR = 21;
const MIN_BLOCK_MIN = 20;
const MINUTES_IN_DAY = 24 * 60;

interface Span {
	start_time: string;
	end_time: string;
}

export interface HourGrid {
	startHour: number;
	endHour: number;
}

export const AgendaGrid = {
	minutesOf(time: string) {
		return Number(time.slice(0, 2)) * 60 + Number(time.slice(3, 5));
	},

	effectiveEnd(span: Span) {
		const end = this.minutesOf(span.end_time);

		return end <= this.minutesOf(span.start_time) ? MINUTES_IN_DAY : end;
	},

	hourGrid(spans: Span[]): HourGrid {
		let startHour = GRID_START_HOUR;
		let endHour = GRID_END_HOUR;

		for (const span of spans) {
			startHour = Math.min(startHour, Math.floor(this.minutesOf(span.start_time) / 60));
			endHour = Math.max(endHour, Math.ceil(this.effectiveEnd(span) / 60));
		}

		return { startHour, endHour };
	},

	blockPosition(span: Span, grid: HourGrid) {
		const gridStart = grid.startHour * 60;
		const gridEnd = grid.endHour * 60;
		const start = Math.max(this.minutesOf(span.start_time), gridStart);
		const end = Math.min(this.effectiveEnd(span), gridEnd);

		const topMin = start - gridStart;
		const heightMin = Math.min(Math.max(end - start, MIN_BLOCK_MIN), gridEnd - start);

		return { topMin, heightMin };
	},

	lanes(spans: Span[]) {
		const result: { lane: number; lanes: number }[] = [];
		let cluster: number[] = [];
		let endByLane: number[] = [];
		let clusterEnd = 0;

		const closeCluster = () => {
			for (const index of cluster) {
				result[index].lanes = endByLane.length;
			}
		};

		for (const [index, span] of spans.entries()) {
			const start = this.minutesOf(span.start_time);

			if (cluster.length > 0 && start >= clusterEnd) {
				closeCluster();
				cluster = [];
				endByLane = [];
			}

			const free = endByLane.findIndex((end) => end <= start);
			const lane = free === -1 ? endByLane.length : free;
			const end = this.effectiveEnd(span);

			endByLane[lane] = end;
			clusterEnd = Math.max(clusterEnd, end);

			cluster.push(index);
			result.push({ lane, lanes: 0 });
		}

		closeCluster();

		return result;
	},
};
